// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notifications-panel {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    margin-top: 30px;
    box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}

.notif-header h3 {
    color: #003366;
    font-size: 18px;
    margin-bottom: 2px;
    display: flex;
    align-items: center;
}

.notif-subtext {
    font-size: 12px;
    color: #666;
    margin-bottom: 12px;
}

.notif-item {
    display: flex;
    border-bottom: 1px solid #eee;
    padding: 10px 0;
}

.notif-icon-wrap {
    margin-right: 10px;
}

.notif-icon {
    font-size: 24px;
}

.notif-content {
    flex: 1 1;
    font-size: 14px;
}

.notif-tag {
    display: inline-block;
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 11px;
    margin-right: 8px;
    font-weight: bold;
    text-transform: uppercase;
}

    .notif-tag.high {
        background: #ffe6e6;
        color: #d10000;
    }

    .notif-tag.moderate {
        background: #fff4cc;
        color: #aa8800;
    }

    .notif-tag.info {
        background: #e0f2ff;
        color: #0077cc;
    }

.notif-time {
    font-size: 12px;
    color: #777;
}
.notifications-panel {
    padding: 1.5rem;
    background: #fefefe;
}

.notifications-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
}

    .notifications-header h2 {
        font-size: 1.25rem;
        color: #1e293b;
        display: flex;
        align-items: center;
    }

.filters select {
    margin-left: 0.5rem;
    padding: 4px 8px;
    font-size: 0.9rem;
    border-radius: 5px;
    border: 1px solid #ccc;
}

.notification-list {
    margin-top: 1rem;
    display: grid;
    gap: 1rem;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
}

.notification-card {
    background: #f8fafc;
    border-left: 5px solid #ccc;
    padding: 1rem;
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(0,0,0,0.05);
}

.card-top {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 0.5rem;
}

.icon {
    font-size: 1.3rem;
}

.meta {
    flex-grow: 1;
}

.badge {
    font-size: 0.75rem;
    padding: 2px 6px;
    border-radius: 4px;
    display: inline-block;
    margin-top: 2px;
}

.high-severity {
    background: #fee2e2;
    color: #b91c1c;
}

.medium-severity {
    background: #fef3c7;
    color: #b45309;
}

.low-severity {
    background: #ecfdf5;
    color: #047857;
}

.message {
    font-size: 0.9rem;
    margin: 0.5rem 0;
}

.ai-suggestion {
    font-size: 0.85rem;
    color: #334155;
}

.ai-label {
    font-weight: bold;
    color: #111827;
}

.timestamp {
    font-size: 0.75rem;
    color: #64748b;
    margin-top: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/NotificationsPanel.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;AAC7B;;IAEI;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;AAEJ;IACI,eAAe;IACf,WAAW;AACf;AACA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;AACnB;;IAEI;QACI,kBAAkB;QAClB,cAAc;QACd,aAAa;QACb,mBAAmB;IACvB;;AAEJ;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,4DAA4D;AAChE;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,aAAa;IACb,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB","sourcesContent":[".notifications-panel {\n    background: #fff;\n    padding: 20px;\n    border-radius: 8px;\n    margin-top: 30px;\n    box-shadow: 0 2px 6px rgba(0,0,0,0.05);\n}\n\n.notif-header h3 {\n    color: #003366;\n    font-size: 18px;\n    margin-bottom: 2px;\n    display: flex;\n    align-items: center;\n}\n\n.notif-subtext {\n    font-size: 12px;\n    color: #666;\n    margin-bottom: 12px;\n}\n\n.notif-item {\n    display: flex;\n    border-bottom: 1px solid #eee;\n    padding: 10px 0;\n}\n\n.notif-icon-wrap {\n    margin-right: 10px;\n}\n\n.notif-icon {\n    font-size: 24px;\n}\n\n.notif-content {\n    flex: 1;\n    font-size: 14px;\n}\n\n.notif-tag {\n    display: inline-block;\n    padding: 2px 6px;\n    border-radius: 4px;\n    font-size: 11px;\n    margin-right: 8px;\n    font-weight: bold;\n    text-transform: uppercase;\n}\n\n    .notif-tag.high {\n        background: #ffe6e6;\n        color: #d10000;\n    }\n\n    .notif-tag.moderate {\n        background: #fff4cc;\n        color: #aa8800;\n    }\n\n    .notif-tag.info {\n        background: #e0f2ff;\n        color: #0077cc;\n    }\n\n.notif-time {\n    font-size: 12px;\n    color: #777;\n}\n.notifications-panel {\n    padding: 1.5rem;\n    background: #fefefe;\n}\n\n.notifications-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n}\n\n    .notifications-header h2 {\n        font-size: 1.25rem;\n        color: #1e293b;\n        display: flex;\n        align-items: center;\n    }\n\n.filters select {\n    margin-left: 0.5rem;\n    padding: 4px 8px;\n    font-size: 0.9rem;\n    border-radius: 5px;\n    border: 1px solid #ccc;\n}\n\n.notification-list {\n    margin-top: 1rem;\n    display: grid;\n    gap: 1rem;\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n}\n\n.notification-card {\n    background: #f8fafc;\n    border-left: 5px solid #ccc;\n    padding: 1rem;\n    border-radius: 8px;\n    box-shadow: 0 1px 4px rgba(0,0,0,0.05);\n}\n\n.card-top {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    margin-bottom: 0.5rem;\n}\n\n.icon {\n    font-size: 1.3rem;\n}\n\n.meta {\n    flex-grow: 1;\n}\n\n.badge {\n    font-size: 0.75rem;\n    padding: 2px 6px;\n    border-radius: 4px;\n    display: inline-block;\n    margin-top: 2px;\n}\n\n.high-severity {\n    background: #fee2e2;\n    color: #b91c1c;\n}\n\n.medium-severity {\n    background: #fef3c7;\n    color: #b45309;\n}\n\n.low-severity {\n    background: #ecfdf5;\n    color: #047857;\n}\n\n.message {\n    font-size: 0.9rem;\n    margin: 0.5rem 0;\n}\n\n.ai-suggestion {\n    font-size: 0.85rem;\n    color: #334155;\n}\n\n.ai-label {\n    font-weight: bold;\n    color: #111827;\n}\n\n.timestamp {\n    font-size: 0.75rem;\n    color: #64748b;\n    margin-top: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
